import React from 'react';

export const giftChairsForSpecialUsersColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'تعداد صندلی',
    dataIndex: 'totalChairs',
    name: 'totalChairs',
    isSortable: false,
  },
  {
    title: 'محدوده ی زمانی',
    dataIndex: 'date',
    name: 'date',
    isSortable: true,
  },
  {
    title: 'صندلی توسط کاربر استفاده شده',
    dataIndex: 'isUsed',
    name: 'isUsed',
    isSortable: false,
    render: isUsed => (
      isUsed === true ?
        <div className='text-success'>
          <i class="far fa-check-square"></i>
        </div>
        :
        <div className='text-danger'>
          <i class="far fa-times-square"></i>
        </div>),
  },
];